export default "__VITE_ASSET__a1cb9cab__"